import {
  ApplicationRef,
  Component,
  ElementRef,
  EnvironmentInjector,
  Input,
  Renderer2,
  Type,
  ViewChild,
  createComponent,
} from "@angular/core";
import { LayoutType } from "./const";
import { ElementComponent } from "./element.component";
import { Layout } from "@app/data/layout";
import { ContainerComponent } from "./container.component";

@Component({
  selector: "n-root",
  template: ``,
  styles: [
    `
      :host ::ng-deep .n-element {
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class RootComponent extends ContainerComponent {}
